import React from 'react';

const TableEmptyCell = () => <td className="align-middle text-center" style={{ width: '1px' }} />;

export default TableEmptyCell;
